<!--
    描述：新增 弹窗
    时间：2020-05-12
    Created by zwh
-->
<template>
	<div class="w-table-layout w-table-page">
        <transition name="fade" mode="out-in">
            <div class="w-table-content" ref="tableContent">
                <el-table ref="objTable" v-loading="tableObj.loading"
                    :border="true" highlight-current-row
                    :height="tableObj.tableH"
                    :data="tableObj.tableData"
                    @selection-change="rowSelectionChange"
                >
                    <el-table-column type="index" align="center" width="50"></el-table-column>
                    <el-table-column type="selection" width="45"></el-table-column>
                    <el-table-column prop="className" label="类名称" show-overflow-tooltip min-width="150"></el-table-column>
                    <el-table-column prop="name" label="接口功能" show-overflow-tooltip min-width="100"></el-table-column>
                    <el-table-column prop="url" label="url" show-overflow-tooltip min-width="120"></el-table-column>
                </el-table>
            </div>
        </transition>
	</div>
</template>

<script>
    import {getAddCheckInterfaceList} from '@/api/modules/sys.js'
    import {saveOnly} from '@/api/modules/menu.js'
    export default {
        props: {
            transObj: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                tableObj: {
                    loading: false,
                    tableH: 500,
                    tableData: []
                },

                checkedList : [],
                objectItem : {
                    menuId : '',
                    interfaceSelection : [],
                },
            }
        },
        created() {
            //获取所有接口信息,已根据菜单id，过了已添加的接口信息
            this.getAddCheckInterfaceInfo();
        },
        computed: {

        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        methods: {
            getAddCheckInterfaceInfo(){  //获取所有接口信息,已根据菜单id，过了已添加的接口信息
                let that = this
                let param = {menuId : that.transObj.menuId}
                getAddCheckInterfaceList(param).then(res => {
                    if (res.operationCode == 1) {
                        that.tableObj.tableData = res.data
                    }
                })
            },
            rowSelectionChange(rows){
                this.objectItem.interfaceSelection = rows
            },
            saveClick(){
                let that = this
                let interfaceSelection = that.objectItem.interfaceSelection.concat()
                if(interfaceSelection.length == 0) return that.$message({ message: '请选择接口信息', type: 'warning' })
                let dataList = interfaceSelection.map(x => {
                    let obj = {
                        menuId: that.transObj.menuId,
                        interfaceId: x.id
                    }
                    return obj
                })
                let param = { menuId: that.menuId, interfaceSelection: dataList }

                saveOnly(param).then(res => {
                    if(res.operationCode==1){
                        that.$message({message: '保存成功',type: 'success'});
                        //刷新菜单信息
                        that.$emit('handle-success', that.transObj)
                    }
                });
            }
        },
    }
</script>

<style scoped>
.w-table-page {
    padding-bottom: 0px;
}
</style>